// Generate a date within 60 days from now for testing expiry warning
const getDateWithinExpiryWindow = (daysFromNow = 30) => {
    const date = new Date()
    date.setDate(date.getDate() + daysFromNow)
    return date.toISOString()
}

const nearExpiryDate = getDateWithinExpiryWindow(30) // 30 days from now

export const tpaBalanceMockData = {
    balance: {
        tracker: {
            warning: false,
            usedSessionBalance: '2500.00',
            currentAvailableBalance: '12984.02',
            nearestExpiryBalanceObj: {
                nearestExpiryBalance: 6971.02,
                nearestExpiryDate: nearExpiryDate
            },
            balanceUsagePercentage: '19.25',
            leftoverOrderAmount: '45.99'
        },
        popup: [
            {
                accountName: 'Health Care FSA',
                balance: 6971.02,
                expiryDate: nearExpiryDate,
                carryoverBalance: 650
            },
            {
                accountName: 'Health Care FSA',
                balance: 2137,
                expiryDate: '2025-12-31T00:00:00.000Z',
                carryoverBalance: 650
            },
            {
                accountName: 'Health Care HSA',
                balance: 2321,
                carryoverBalance: 650
            },
            {
                accountName: 'Health Care HRA',
                balance: 1555,
                expiryDate: '2025-12-31T00:00:00.000Z',
                carryoverBalance: 650
            }
        ]
    },
    popup: {
        type: 'welcome',
        show: false,
        message: 'Welcome! Your Health Care HRA and FSA funds* are ready to use.',
        planType: 'HRA|FSA',
        link: '',
        linkText: 'Learn More about HRA',
        logoVariant: 'direct_pay',
        marketingConsentCheckbox: {
            show: true,
            value: true,
            label: 'Sign up for emails and get early access to sales, helpful tips, and more.<br>I\'ve read, understand and agree to the <a href="https://hsastore.com/terms-and-conditions.html" target="_blank">Terms & Conditions</a> and <a href="https://hsastore.com/privacy-policy.html" target="_blank">Privacy Policy</a>.'
        }
    }
}
export const trackerMockDataSubFields = [
    {
        name: 'tracker',
        type: 'object',
        subFields: [
            {
                name: 'warning',
                type: 'boolean',
                required: true,
                defaultValue: false
            },
            {
                name: 'usedSessionBalance',
                type: 'string',
                required: true,
                defaultValue: '2500.00'
            },
            {
                name: 'currentAvailableBalance',
                type: 'string',
                required: true,
                defaultValue: '12984.02'
            },
            {
                name: 'nearestExpiryBalanceObj',
                type: 'object',
                subFields: [
                    {
                        name: 'nearestExpiryBalance',
                        type: 'number',
                        required: false,
                        defaultValue: 6971.02
                    },
                    {
                        name: 'nearestExpiryDate',
                        type: 'string',
                        required: false,
                        defaultValue: nearExpiryDate
                    }
                ]
            },
            {
                name: 'balanceUsagePercentage',
                type: 'string',
                required: true,
                defaultValue: '19.25'
            },
            {
                name: 'leftoverOrderAmount',
                type: 'string',
                defaultValue: '45.99'
            }
        ]
    },
    {
        name: 'popup',
        type: 'list',
        required: true,
        defaultValue: [
            {
                accountName: 'Health Care FSA',
                balance: 6971.02,
                expiryDate: nearExpiryDate,
                carryoverBalance: 650
            },
            {
                accountName: 'Health Care FSA',
                balance: 2137,
                expiryDate: '2025-12-31T00:00:00.000Z',
                carryoverBalance: 650
            },
            {
                accountName: 'Health Care HSA',
                balance: 2321,
                carryoverBalance: 650
            },
            {
                accountName: 'Health Care HRA',
                balance: 1555,
                expiryDate: '2025-12-31T00:00:00.000Z',
                carryoverBalance: 650
            }
        ],
        subFields: [
            {
                name: 'accountName',
                type: 'string',
                required: true,
                defaultValue: 'Health Care FSA'
            },
            {
                name: 'balance',
                type: 'number',
                required: true,
                defaultValue: 0
            },
            {
                name: 'expiryDate',
                type: 'string'
            },
            {
                name: 'carryoverBalance',
                type: 'number',
                defaultValue: 0
            }
        ]
    }
]

export const popupMockDataSubFields = [
    {
        name: 'type',
        type: 'string',
        defaultValue: 'welcome'
    },
    {
        name: 'show',
        type: 'boolean',
        required: true,
        defaultValue: false
    },
    {
        name: 'message',
        type: 'longText',
        required: true,
        defaultValue: 'Welcome! Your Health Care HRA and FSA funds* are ready to use.'
    },
    {
        name: 'marketingConsentCheckbox',
        type: 'object',
        defaultValue: {
            show: true,
            value: true,
            label: 'Sign up for emails and get early access to sales, helpful tips, and more.<br>I\'ve read, understand and agree to the <a href="https://hsastore.com/terms-and-conditions.html" target="_blank">Terms & Conditions</a> and <a href="https://hsastore.com/privacy-policy.html" target="_blank">Privacy Policy</a>.'
        },
        subFields: [
            {
                name: 'show',
                type: 'boolean',
                defaultValue: true
            },
            {
                name: 'value',
                type: 'boolean',
                defaultValue: true
            },
            {
                name: 'label',
                type: 'string',
                defaultValue:
                    'Sign up for emails and get early access to sales, helpful tips, and more.<br>I\'ve read, understand and agree to the <a href="https://hsastore.com/terms-and-conditions.html" target="_blank">Terms & Conditions</a> and <a href="https://hsastore.com/privacy-policy.html" target="_blank">Privacy Policy</a>.'
            }
        ]
    },
    {
        name: 'planType',
        type: 'string',
        defaultValue: 'HRA|FSA'
    },
    {name: 'link', type: 'string', defaultValue: ''},
    {name: 'linkText', type: 'string', defaultValue: 'Learn More about HRA'},
    {name: 'logoVariant', type: 'string', defaultValue: 'direct_pay'}
]
